import { put, call } from 'redux-saga/effects';
import { caseCreateAPI, caseSearchAPI, caseUpdateAPI, coApplicantDeleteAPI } from 'src/api/CaseApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { CASE_ACTIONS } from '../actions/CaseActions';

function* search({
    where,
    currentPage = 0,
    sortBy = 'ts',
    sortOrder = -1,
    autopopulate = true,
    fullTextSearch = true,
} = {}) {
    try {
        const {
            data: { data },
        } = yield call(caseSearchAPI, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
            }),
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            sortBy,
            sortOrder,
            autopopulate,
        });

        yield put({
            type: CASE_ACTIONS.CASE_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: CASE_ACTIONS.CASE_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({ _id }) {
    try {
        const {
            data: {
                data: { data },
            },
        } = yield call(caseSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        const {
            data: {
                data: { data: populatedData },
            },
        } = yield call(caseSearchAPI, {
            where: {
                _id,
            },
            autopopulate: true,
        });

        if (!data || !data[0]) {
            // DATA NO FOUND
            yield put(
                headerShowAction({
                    data: 'Unable to Edit, something when wrong',
                }),
            );
        }

        // add in reducer
        yield put({
            type: CASE_ACTIONS.CASE_UPSERT_SUCCESS,
            data: data[0],
            populatedData: populatedData[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(
            headerShowAction({
                data: error.response.data.data,
            }),
        );

        yield put(
            headerShowAction({
                data: error.response.data.data,
            }),
        );
    }
}

function* insert(payload) {
    try {
        const {
            data: { data },
        } = yield call(caseCreateAPI, payload);

        yield put(
            headerShowAction({
                data: 'Created',
            }),
        );

        // add in reducer
        yield put({
            type: CASE_ACTIONS.CASE_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });

        // updated latest data from server
        yield edit({ _id: data._id });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        if(error.response.data.data.code===501)
        {
            yield put(
                headerShowAction({
                    data: error.response.data.data.message,
                }),
            );
            if(window.confirm(error.response.data.data.message+' edit ✏️ to mark Sold.'))
            {
                yield edit({ _id: error.response.data.data.oldRecId });
            }
           
        }
        else{
            yield put(
                headerShowAction({
                    data: error.response.data.data,
                }),
            );
        }
        yield put({
            type: CASE_ACTIONS.CASE_UPSERT_ERROR,
        });

    }
}

function* update(caseId, payload) {
    try {
        yield call(caseUpdateAPI, {
            caseId,
            data: payload,
        });

        yield put(
            headerShowAction({
                data: 'Updated',
            }),
        );

        yield edit({ _id: caseId });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(
            headerShowAction({
                data: error.response.data.data,
            }),
        );

        yield put({
            type: CASE_ACTIONS.CASE_UPSERT_ERROR,
        });
    }
}

function* upsert({ _id, ...payload }) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}
function* remove({
    caseId,
    _id,
}) {
    try {
        // delete
        yield call(coApplicantDeleteAPI, {
            caseId,
            _id
        });

        // show message
        yield put(headerShowAction({
            data: 'Co-Applicant Removed.',
        }));
        yield edit({ _id: caseId });
    }
    catch (error) {
        console.error('LOG: delete error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

export default [
    takeFirstSagaUtil(CASE_ACTIONS.CASE_SEARCH, search),
    takeFirstSagaUtil(CASE_ACTIONS.CASE_UPSERT, upsert),
    takeFirstSagaUtil(CASE_ACTIONS.CASE_EDIT, edit),
    takeFirstSagaUtil(CASE_ACTIONS.CO_APPLICANT_REMOVE, remove),
];
